// @flow
import { EstadisticasActionTypes } from './constants';

type EstadisticasAction = { type: string, payload: {} | string };

// common success
export const estadisticasApiResponseSuccess = (actionType: string, data: any): EstadisticasAction => ({
    type: EstadisticasActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const estadisticasApiResponseError = (actionType: string, error: string): EstadisticasAction => ({
    type: EstadisticasActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const addEstadistica = (estadistica:any):EstadisticasAction=>({
    type:EstadisticasActionTypes.ADD_ESTADISTICA,
    payload:estadistica
})

export const listEstadisticas = (params:any): EstadisticasAction => ({
    type: EstadisticasActionTypes.LIST_ESTADISTICAS,
    payload: params,
});

export const resetEstadisticas = (): EstadisticasAction => ({
    type: EstadisticasActionTypes.RESET,
    payload: {},
});

